import { Component } from 'vue-property-decorator'

import { Measurements } from '@src/routes/members/measurements'
import { MemberProfile } from '@src/data/member-profile'

import './measurements.sass'

@Component({
  computed: {
    member () {
      return this.$store.state.memberProfile
    },
    gender () {
      return this.$store.state.memberProfile.gender
    }
  }
})
export class ReadonlyMeasurements extends Measurements {

  member: MemberProfile
  gender: string

  setDocumentTitle () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.BODY_MEASUREMENTS')}`
  }

  protected loadBodyMeasurements (): any {
    this.loading = false
    this.bodyMeasurements = this.member
  }
}
